export default "__VITE_ASSET__5c6ffea0__"